import { Component, EventEmitter, Injector, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AppComponentBase } from '@shared/app-component-base';
import { AnexoConsultaDto, ConsultaServiceProxy, TipoUsuarioEnum, UpdateConsultaDto } from '@shared/service-proxies/service-proxies';
import { finalize } from '@node_modules/rxjs/operators';

@Component({
  selector: 'app-modal-visualizar-anexos',
  templateUrl: './modal-visualizar-anexos.component.html',
  styleUrls: ['./modal-visualizar-anexos.component.scss']
})
export class ModalVisualizarAnexosComponent extends AppComponentBase implements OnInit {

  public consulta: UpdateConsultaDto = new UpdateConsultaDto();
  public tipoUsuario: TipoUsuarioEnum = TipoUsuarioEnum._0;
  protected saving: boolean = false;
  @Output() onSave = new EventEmitter<any>();

  constructor(
    injector: Injector,
    public bsModalRef: BsModalRef,
    private readonly _consultaService: ConsultaServiceProxy
  ) { super(injector) }

  ngOnInit(): void {
    this.consulta.novosAnexos = []
    this.consulta.anexosRemovidos = []
  }

  protected save(): void {
    abp.ui.setBusy();
    this.saving = true;
    this.consulta.anexos = [];
    this._consultaService.update(this.consulta).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.onSave.emit();
      this.bsModalRef.hide();
    });
  }

  protected addFile(files: AnexoConsultaDto[]): void {
    this.consulta.novosAnexos = [...files];
  }

  protected removeFile(files: AnexoConsultaDto[]): void {
    this.consulta.anexosRemovidos = [...files];
  }
}
